export const FETCH_SELENIUM_LOGS_LOADING = "FETCH_SELENIUM_LOGS_LOADING";
export const FETCH_SELENIUM_LOGS_SUCCESS = "FETCH_SELENIUM_LOGS_SUCCESS";
export const FETCH_SELENIUM_LOGS_FAILED = "FETCH_SELENIUM_LOGS_FAILED";
export const CLEAR_SELENIUM_LOGS = "CLEAR_SELENIUM_LOGS";
